/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Admin from './Admin/index'
import CalendarSettings from './CalendarSettings/index'
import Chairs from './Chairs/index'
import Charges from './Charges/index'
import Comms from './Comms/index'
import CommsEmail from './CommsEmail/index'
import CommsSettings from './CommsSettings/index'
import ConnectApps from './ConnectApps/index'
import ConnectDevelopers from './ConnectDevelopers/index'
import DocumentTemplates from './DocumentTemplates/index'
import FeatureFlags from './FeatureFlags/index'
import HrAdmin from './HrAdmin/index'
import Leads from './Leads/index'
import MedicalHistory from './MedicalHistory/index'
import No from './No/index'
import NoteTemplates from './NoteTemplates/index'
import Nps from './Nps/index'
import Onboarding from './Onboarding/index'
import PatientHub from './PatientHub/index'
import PayApp from './PayApp/index'
import PaymentProviders from './PaymentProviders/index'
import Procedures from './Procedures/index'
import React from 'react'
import Schedules from './Schedules/index'
import SecureValue from './SecureValue/index'
import SuspenseBoundary from 'DesignSystem/SuspenseBoundary/index'
import TracedCephs from './TracedCephs/index'
import TreatmentAutomations from './TreatmentAutomations/index'
import TreatmentCard from './TreatmentCard/index'
import TreatmentCaseCloser from './TreatmentCaseCloser/index'
import TreatmentPayments from './TreatmentPayments/index'
import TreatmentPlanTemplates from './TreatmentPlanTemplates/index'
let Icons = React.lazy(() => import('./Icons/index'))
let Simple = React.lazy(() => import('./Simple/index'))



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/Content"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let tabSelectedTabValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.tab',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: tabSelectedTabValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Nps'}>
<Nps
  viewPath={`${viewPath}/Nps`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Comms'}>
<Comms
  viewPath={`${viewPath}/Comms`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'CommsEmail'}>
<CommsEmail
  viewPath={`${viewPath}/CommsEmail`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'CommsSettings'}>
<CommsSettings
  viewPath={`${viewPath}/CommsSettings`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'PatientHub'}>
<PatientHub
  viewPath={`${viewPath}/PatientHub`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'PayApp'}>
<PayApp
  viewPath={`${viewPath}/PayApp`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'TreatmentAutomations'}>
<TreatmentAutomations
  viewPath={`${viewPath}/TreatmentAutomations`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'TreatmentCard'}>
<TreatmentCard
  viewPath={`${viewPath}/TreatmentCard`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'TreatmentPlanTemplates'}>
<TreatmentPlanTemplates
  viewPath={`${viewPath}/TreatmentPlanTemplates`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'TreatmentPayments'}>
<TreatmentPayments
  viewPath={`${viewPath}/TreatmentPayments`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'TreatmentCaseCloser'}>
<TreatmentCaseCloser
  viewPath={`${viewPath}/TreatmentCaseCloser`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'DocumentTemplates'}>
<DocumentTemplates
  viewPath={`${viewPath}/DocumentTemplates`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'NoteTemplates'}>
<NoteTemplates
  viewPath={`${viewPath}/NoteTemplates`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'TracedCephs'}>
<TracedCephs
  viewPath={`${viewPath}/TracedCephs`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'MedicalHistory'}>
<MedicalHistory
  viewPath={`${viewPath}/MedicalHistory`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Chairs'}>
<Chairs
  viewPath={`${viewPath}/Chairs`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Schedules'}>
<Schedules
  viewPath={`${viewPath}/Schedules`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'CalendarSettings'}>
<CalendarSettings
  viewPath={`${viewPath}/CalendarSettings`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Admin'}>
<Admin
  viewPath={`${viewPath}/Admin`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'HrAdmin'}>
<HrAdmin
  viewPath={`${viewPath}/HrAdmin`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'SecureValue'}>
<SecureValue
  viewPath={`${viewPath}/SecureValue`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'ConnectApps'}>
<ConnectApps
  viewPath={`${viewPath}/ConnectApps`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'ConnectDevelopers'}>
<ConnectDevelopers
  viewPath={`${viewPath}/ConnectDevelopers`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'FeatureFlags'}>
<FeatureFlags
  viewPath={`${viewPath}/FeatureFlags`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'PaymentProviders'}>
<PaymentProviders
  viewPath={`${viewPath}/PaymentProviders`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Onboarding'}>
<Onboarding
  viewPath={`${viewPath}/Onboarding`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Leads'}>
<Leads
  viewPath={`${viewPath}/Leads`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Charges'}>
<Charges
  viewPath={`${viewPath}/Charges`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Procedures'}>
<Procedures
  viewPath={`${viewPath}/Procedures`}
/>
</fromFlow.When>
<SuspenseBoundary
  viewPath={`${viewPath}/SuspenseBoundary`}
>
{childProps => (
<fromFlow.When is={flowValue === 'Icons'}>
<Icons
{...childProps}
  viewPath={`${viewPath}/Icons`}
/>
</fromFlow.When>
)}
</SuspenseBoundary>
<SuspenseBoundary
  viewPath={`${viewPath}/SuspenseBoundary`}
>
{childProps => (
<fromFlow.When is={flowValue === 'Simple'}>
<Simple
{...childProps}
  viewPath={`${viewPath}/Simple`}
/>
</fromFlow.When>
)}
</SuspenseBoundary>
{children}
</React.Fragment>)
}